import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UserInfoDialogData {
  user: any;
}

export interface UserInfo {
  name: string;
  username: string;
  email?: string;
  mobile?: string;
  userType?: string;
  userTypeClass?: string;
  role?: string;
  regions?: any[];
  sites?: any[];
}

@Component({
  selector: 'app-user-info-dialog',
  templateUrl: './user-info-dialog.component.html',
  styleUrls: ['./user-info-dialog.component.scss']
})
export class UserInfoDialogComponent {
  userInfo: UserInfo;

  constructor(
    public dialogRef: MatDialogRef<UserInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserInfoDialogData
  ) {
    this.userInfo = this.processUserData(data.user);
  }

  private processUserData(user: any): UserInfo {
    const metadata = user.metadata || {};
    
    return {
      name: user.label || metadata.name || user.name || 'Unknown User',
      username: user.value || user.username || '',
      email: metadata.email || user.email || '',
      mobile: metadata.mobile || user.mobile || metadata.phone || '',
      userType: metadata.userType || user.userType || '',
      userTypeClass: metadata.userTypeClass || user.userTypeClass || '',
      role: metadata.role || user.role || '',
      regions: metadata.regions || user.regions || [],
      sites: metadata.sites || user.sites || []
    };
  }

  getPageTitle(): string {
    return this.userInfo && this.userInfo.userType ? this.userInfo.userType.toLocaleLowerCase() == 'admin'? `Associated Regions (${this.userInfo.regions.length})`: `Associated Sites (${this.userInfo.sites.length})` : 'Association Information';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}